var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationCity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.5V5.5L12 2.5L9 5.5V7.5H3V21.5H21V11.5H15ZM7 19.5H5V17.5H7V19.5ZM7 15.5H5V13.5H7V15.5ZM7 11.5H5V9.5H7V11.5ZM13 19.5H11V17.5H13V19.5ZM13 15.5H11V13.5H13V15.5ZM13 11.5H11V9.5H13V11.5ZM13 7.5H11V5.5H13V7.5ZM19 19.5H17V17.5H19V19.5ZM19 15.5H17V13.5H19V15.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationCity);
export default __webpack_public_path__ + "static/media/location_city.6a2feb948f97ba92bc6636a924f85260.svg";
export { ForwardRef as ReactComponent };